import { ReceiptStatus } from './receipt-status.js';
export const TERMINAL_RECEIPT_STATUS_IDS = [
    ReceiptStatus.FULFILLED,
    ReceiptStatus.VOID,
];
//# sourceMappingURL=receipt-terminal-statuses.js.map